import React from "react";
import PropTypes from "prop-types";
import { ContextMenuTrigger } from "react-contextmenu";
import { Icon } from "rhombus-react";


export default function Trigger({ id, icon = "moreHorizontal", isDisabled }){
	let isDisabledClass = isDisabled ? "is-disabled" : "";

	return (
		<ContextMenuTrigger
			id={`context-menu-${id}`}
			holdToDisplay = {0}
			disable={isDisabled}
			 // Setting a very low open delay makes it open on left click.
		>
			<Icon name={icon} className={`trigger-icon ${isDisabledClass}`} />
		</ContextMenuTrigger>
	);
}

Trigger.defaultProps = {
	id:null,
	icon:"moreHorizontal",
	isDisabled:false,
};
Trigger.propTypes={
	id:PropTypes.any,
	icon:PropTypes.string,
	isDisabled:PropTypes.bool,
};
